import { Dayjs } from "dayjs";
import { usState } from "./states";
import dayjs from 'dayjs';

export interface GCUsageModel {
    
    // Usage Information
    cardLastUsedDate: Dayjs | null;
    stateLastUsed: usState | null;
    usageRequired: boolean;
}

export interface GCUsageErrors {
    cardLastUsedDateError: boolean;
    stateLastUsedError: boolean;
    errors: string[];
}

export const validateGCUsage = (gcUsage: GCUsageModel) : GCUsageErrors => { 
    let errors: GCUsageErrors = {
        cardLastUsedDateError: false,
        stateLastUsedError: false,
        errors: []
    };
    
    if (gcUsage.usageRequired) {
        // Validate Card Last Used Date
        if (gcUsage.cardLastUsedDate === null) {
            errors.cardLastUsedDateError = true;
            errors.errors.push('Card Last Used Date is required');
        }
        else if (gcUsage.cardLastUsedDate.isAfter(dayjs(), 'year')){
            errors.cardLastUsedDateError = true;
            errors.errors.push('Card Last Used Date cannot be in the future');
        }

        // Validate State Last Used
        if (gcUsage.stateLastUsed === null) {
            errors.stateLastUsedError = true;
            errors.errors.push('State Last Used is required');
        }
    }

    return errors;
}

export const defaultGCUsageModel = () : GCUsageModel => {
    return {
        // Usage Information
        cardLastUsedDate: null,
        stateLastUsed: null,
        usageRequired: false
    }
}